module.exports = {
  'WECHAT_FRIENDS':0,
  'WECHAT_TIMELINE': 1,
  'QQ': 2,
  'SMS': 3,
  'WEIBO': 4,
  'QZONE': 5,
  'EMAIL': 6,
  'COPY': 7
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/dpapp/share.js
// module id = 172
// module chunks = 10 11 12 13 14 15 16 17 18 19